// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 506) return "js/506.js";
	if (chunkId === 167) return "js/167.js";
	// return url for filenames based on template
	return undefined;
};